import{Cookies as i}from"@edikk-edikk/shared";import{INVERSIFY_TYPES as t}from"./inversify-types.js";const e=o=>{o.bind(t.cookies).to(i).inSingletonScope()};export{e as initCookies};
